import { chatBotMessageRef } from './consts';

export default function (editor, opts = {}) {
  const { label, category } = opts;
  const bm = editor.BlockManager;
  const style = `
  <style>
  .${chatBotMessageRef} .chatbox-wrapper {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    width: 4rem;
    height: 4rem;
  }
  .${chatBotMessageRef} .chatbox-toggle {
    width: 100%;
    height: 100%;
    background: #335dff;
    color: #fff;
    font-size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    transition: 0.2s;
  }
  .${chatBotMessageRef} .chatbox-toggle:active {
    transform: scale(0.9);
  }
  .${chatBotMessageRef} .chatbox-message-wrapper {
    position: absolute;
    bottom: calc(100% + 1rem);
    right: 0;
    width: 420px;
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: 0.5rem 0.5rem 2rem rgba(0, 0, 0, 0.1);
    transform: scale(0);
    transform-origin: bottom right;
    transition: 0.2s;
  }
  .${chatBotMessageRef} .chatbox-message-wrapper.show {
    transform: scale(1);
  }
  .${chatBotMessageRef} .chatbox-message-header {
    background: #fff;
    padding: 5px 20px;
  }
  .${chatBotMessageRef} .chatbox-message-dropdown{
    cursor: pointer;
  }
  .${chatBotMessageRef} .chatbox-message-content {
    background: #f5f5f5;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    grid-row-gap: 1rem;
    max-height: 300px;
    overflow-y: auto;
  }
  .${chatBotMessageRef} .chatbox-message-item {
    width: 90%;
    padding: 1rem;
  }
  .${chatBotMessageRef} .chatbox-message-item.sent {
    align-self: flex-end;
    background: #335dff;
    color: #fff;
    border-radius: 0.75rem 0 0.75rem 0.75rem;
  }
  .${chatBotMessageRef} .chatbox-message-item.received {
    background: #fff;
    border-radius: 0 0.75rem 0.75rem 0.75rem;
    box-shadow: 0.25rem 0.25rem 1.5rem rgba(0, 0, 0, 0.05);
  }
  .${chatBotMessageRef} .chatbox-message-item-time {
    float: right;
    font-size: 0.75rem;
    margin-top: 0.5rem;
    display: inline-block;
  }
  .${chatBotMessageRef} .chatbox-message-bottom {
    background: #fff;
    padding: 0.75rem 1.5rem;
  }
  .${chatBotMessageRef} .chatbox-message-form {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f5f5f5;
    border-radius: 0.5rem;
    padding: 0.5rem 1.25rem;
  }
  .${chatBotMessageRef} .chatbox-message-input {
    background: transparent;
    outline: none;
    border: none;
    resize: none;
    scrollbar-width: none;
  }
  .${chatBotMessageRef} .chatbox-message-input::-webkit-scrollbar {
    display: none;
  }
  .${chatBotMessageRef} .chatbox-message-submit {
    font-size: 1.25rem;
    color: #335dff;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
  }
  </style>
`;
  bm.add(chatBotMessageRef, {
    label: `<i class="webconnect-chat-left-quote"></i><div>${label}</div>`,
    category: category,
    content: `
    <div class="${chatBotMessageRef}" data-gjs-type="${chatBotMessageRef}" data-js="${chatBotMessageRef}">
      <img src="https://drapcode-static.s3.amazonaws.com/img/chat-bot.png" alt="Message" data-gjs-custom-name="Message Placeholder" data-gjs-droppable="false" data-gjs-draggable="false" data-gjs-removable="false" data-gjs-copyable="false" data-gjs-selectable="false" data-gjs-highlightable="false"/>
    </div>${style}`,
    render: ({ model, className }) => `
    <div class="${className}-label ${className}__drapcode-wrap">
    ${model.get('label')}
    </div>

    <span class="${className}__info no-doc">
      <a target="_blank" href="#" draggable="false">
        <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label}?"></i>
      </a>
    </span>
  `,
  });
}
